import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class IrisFlagService {
  flags = [
    { 'id': 'flag flag-gu', 'name': 'label.country.Guam' },
    { 'id': 'flag flag-mn', 'name': 'label.country.Mongolia' },
    { 'id': 'flag flag-va', 'name': 'label.country.HolySee' },
    { 'id': 'flag flag-tibet', 'name': 'label.country.Tibet' },
    { 'id': 'flag flag-fo', 'name': 'label.country.FaroeIslands' },
    { 'id': 'flag flag-th', 'name': 'label.country.Thailand' },
    { 'id': 'flag flag-tr', 'name': 'label.country.Turkey' },
    { 'id': 'flag flag-tl', 'name': 'label.country.TimorLeste' },
    { 'id': 'flag flag-kz', 'name': 'label.country.Kazakhstan' },
    { 'id': 'flag flag-zm', 'name': 'label.country.Zambia' },
    { 'id': 'flag flag-uz', 'name': 'label.country.Uzbekistan' },
    { 'id': 'flag flag-dk', 'name': 'label.country.Denmark' },
    { 'id': 'flag flag-scotland', 'name': 'label.country.Scotland' },
    { 'id': 'flag flag-gi', 'name': 'label.country.Gibraltar' },
    { 'id': 'flag flag-gy', 'name': 'label.country.Guyana' },
    { 'id': 'flag flag-bj', 'name': 'label.country.Benin' },
    { 'id': 'flag flag-fr', 'name': 'label.country.France' },
    { 'id': 'flag flag-mo', 'name': 'label.country.Macau' },
    { 'id': 'flag flag-ir', 'name': 'label.country.Iran' },
    { 'id': 'flag flag-io', 'name': 'label.country.BritishIndianOceanTerritory' },
    { 'id': 'flag flag-tm', 'name': 'label.country.Turkmenistan' },
    { 'id': 'flag flag-ch', 'name': 'label.country.Switzerland' },
    { 'id': 'flag flag-mt', 'name': 'label.country.Malta' },
    { 'id': 'flag flag-nl', 'name': 'label.country.Netherlands' },
    { 'id': 'flag flag-gp', 'name': 'label.country.Guadeloupe' },
    { 'id': 'flag flag-im', 'name': 'label.country.IsleOfMan' },
    { 'id': 'flag flag-tv', 'name': 'label.country.Tuvalu' },
    { 'id': 'flag flag-mu', 'name': 'label.country.Mauritius' },
    { 'id': 'flag flag-pe', 'name': 'label.country.Peru' },
    { 'id': 'flag flag-vi', 'name': 'label.country.VirginIslands' },
    { 'id': 'flag flag-hn', 'name': 'label.country.Honduras' },
    { 'id': 'flag flag-ss', 'name': 'label.country.SouthSudan' },
    { 'id': 'flag flag-ae', 'name': 'label.country.UnitedArabEmirates' },
    { 'id': 'flag flag-td', 'name': 'label.country.Chad' },
    { 'id': 'flag flag-pw', 'name': 'label.country.Palau' },
    { 'id': 'flag flag-nu', 'name': 'label.country.Niue' },
    { 'id': 'flag flag-bt', 'name': 'label.country.Bhutan' },
    { 'id': 'flag flag-ms', 'name': 'label.country.Montserrat' },
    { 'id': 'flag flag-cv', 'name': 'label.country.CaboVerde' },
    { 'id': 'flag flag-es', 'name': 'label.country.Spain' },
    { 'id': 'flag flag-mh', 'name': 'label.country.MarshallIslands' },
    { 'id': 'flag flag-la', 'name': 'label.country.Laos' },
    { 'id': 'flag flag-vn', 'name': 'label.country.Vietnam' },
    { 'id': 'flag flag-py', 'name': 'label.country.Paraguay' },
    { 'id': 'flag flag-br', 'name': 'label.country.Brazil' },
    { 'id': 'flag flag-ye', 'name': 'label.country.Yemen' },
    { 'id': 'flag flag-ie', 'name': 'label.country.Ireland' },
    { 'id': 'flag flag-gh', 'name': 'label.country.Ghana' },
    { 'id': 'flag flag-cg', 'name': 'label.country.RepublicOfTheCongo' },
    { 'id': 'flag flag-cu', 'name': 'label.country.Cuba' },
    { 'id': 'flag flag-hu', 'name': 'label.country.Hungary' },
    { 'id': 'flag flag-sg', 'name': 'label.country.Singapore' },
    { 'id': 'flag flag-at', 'name': 'label.country.Austria' },
    { 'id': 'flag flag-lk', 'name': 'label.country.SriLanka' },
    { 'id': 'flag flag-vu', 'name': 'label.country.Vanuatu' },
    { 'id': 'flag flag-bo', 'name': 'label.country.Bolivia' },
    { 'id': 'flag flag-jo', 'name': 'label.country.Jordan' },
    { 'id': 'flag flag-er', 'name': 'label.country.Eritrea' },
    { 'id': 'flag flag-za', 'name': 'label.country.SouthAfrica' },
    { 'id': 'flag flag-rs', 'name': 'label.country.Serbia' },
    { 'id': 'flag flag-nr', 'name': 'label.country.Nauru' },
    { 'id': 'flag flag-ls', 'name': 'label.country.Lesotho' },
    { 'id': 'flag flag-jm', 'name': 'label.country.Jamaica' },
    { 'id': 'flag flag-tz', 'name': 'label.country.Tanzania' },
    { 'id': 'flag flag-ki', 'name': 'label.country.Kiribati' },
    { 'id': 'flag flag-sj', 'name': 'label.country.SvalbardAndJanMayen' },
    { 'id': 'flag flag-cz', 'name': 'label.country.CzechRepublic' },
    { 'id': 'flag flag-pg', 'name': 'label.country.PapuaNewGuinea' },
    { 'id': 'flag flag-lv', 'name': 'label.country.Latvia' },
    { 'id': 'flag flag-do', 'name': 'label.country.DominicanRepublic' },
    { 'id': 'flag flag-lu', 'name': 'label.country.Luxembourg' },
    { 'id': 'flag flag-no', 'name': 'label.country.Norway' },
    { 'id': 'flag flag-kw', 'name': 'label.country.Kuwait' },
    { 'id': 'flag flag-mx', 'name': 'label.country.Mexico' },
    { 'id': 'flag flag-yt', 'name': 'label.country.Mayotte' },
    { 'id': 'flag flag-ly', 'name': 'label.country.Libya' },
    { 'id': 'flag flag-cy', 'name': 'label.country.Cyprus' },
    { 'id': 'flag flag-ph', 'name': 'label.country.Philippines' },
    { 'id': 'flag flag-my', 'name': 'label.country.Malaysia' },
    { 'id': 'flag flag-sm', 'name': 'label.country.SanMarino' },
    { 'id': 'flag flag-et', 'name': 'label.country.Ethiopia' },
    { 'id': 'flag flag-ru', 'name': 'label.country.Russia' },
    { 'id': 'flag flag-tj', 'name': 'label.country.Tajikistan' },
    { 'id': 'flag flag-ai', 'name': 'label.country.Anguilla' },
    { 'id': 'flag flag-pl', 'name': 'label.country.Poland' },
    { 'id': 'flag flag-kp', 'name': 'label.country.NorthKorea' },
    { 'id': 'flag flag-uy', 'name': 'label.country.Uruguay' },
    { 'id': 'flag flag-gb', 'name': 'label.country.UnitedKingdom' },
    { 'id': 'flag flag-gs', 'name': 'label.country.SouthGeorgiaAndTheSouthSandwichIslands' },
    { 'id': 'flag flag-kurdistan', 'name': 'label.country.Kurdistan' },
    { 'id': 'flag flag-rw', 'name': 'label.country.Rwanda' },
    { 'id': 'flag flag-ec', 'name': 'label.country.Ecuador' },
    { 'id': 'flag flag-mm', 'name': 'label.country.Myanmar' },
    { 'id': 'flag flag-pa', 'name': 'label.country.Panama' },
    { 'id': 'flag flag-wales', 'name': 'label.country.Wales' },
    { 'id': 'flag flag-kg', 'name': 'label.country.Kyrgyzstan' },
    { 'id': 'flag flag-ve', 'name': 'label.country.Venezuela' },
    { 'id': 'flag flag-tk', 'name': 'label.country.Tokelau' },
    { 'id': 'flag flag-ca', 'name': 'label.country.Canada' },
    { 'id': 'flag flag-is', 'name': 'label.country.Iceland' },
    { 'id': 'flag flag-ke', 'name': 'label.country.Kenya' },
    { 'id': 'flag flag-ro', 'name': 'label.country.Romania' },
    { 'id': 'flag flag-gq', 'name': 'label.country.EquatorialGuinea' },
    { 'id': 'flag flag-pt', 'name': 'label.country.Portugal' },
    { 'id': 'flag flag-tf', 'name': 'label.country.FrenchSouthernTerritories' },
    { 'id': 'flag flag-ad', 'name': 'label.country.Andorra' },
    { 'id': 'flag flag-sk', 'name': 'label.country.Slovakia' },
    { 'id': 'flag flag-pm', 'name': 'label.country.SaintPierreAndMiquelon' },
    { 'id': 'flag flag-om', 'name': 'label.country.Oman' },
    { 'id': 'flag flag-an', 'name': 'label.country.NetherlandsAntilles' },
    { 'id': 'flag flag-ws', 'name': 'label.country.Samoa' },
    { 'id': 'flag flag-sh', 'name': 'label.country.SaintHelenaAscensionAndTristanDaCunh' },
    { 'id': 'flag flag-mp', 'name': 'label.country.NorthernMarianaIslands' },
    { 'id': 'flag flag-gt', 'name': 'label.country.Guatemala' },
    { 'id': 'flag flag-cf', 'name': 'label.country.CentralAfricanRepublic' },
    { 'id': 'flag flag-zanzibar', 'name': 'label.country.Zanzibar' },
    { 'id': 'flag flag-mw', 'name': 'label.country.Malawi' },
    { 'id': 'flag flag-catalonia', 'name': 'label.country.Catalonia' },
    { 'id': 'flag flag-ug', 'name': 'label.country.Uganda' },
    { 'id': 'flag flag-je', 'name': 'label.country.Jersey' },
    { 'id': 'flag flag-km', 'name': 'label.country.Comoros' },
    { 'id': 'flag flag-in', 'name': 'label.country.India' },
    { 'id': 'flag flag-bf', 'name': 'label.country.BurkinaFaso' },
    { 'id': 'flag flag-mc', 'name': 'label.country.Monaco' },
    { 'id': 'flag flag-sy', 'name': 'label.country.SyrianArabRepublic' },
    { 'id': 'flag flag-sn', 'name': 'label.country.Senegal' },
    { 'id': 'flag flag-kr', 'name': 'label.country.SouthKorea' },
    { 'id': 'flag flag-eu', 'name': 'label.country.EuropeanUnion' },
    { 'id': 'flag flag-bn', 'name': 'label.country.BruneiDarussalam' },
    { 'id': 'flag flag-st', 'name': 'label.country.SaoTomeAndPrincipe' },
    { 'id': 'flag flag-england', 'name': 'label.country.England' },
    { 'id': 'flag flag-lc', 'name': 'label.country.SaintLucia' },
    { 'id': 'flag flag-dm', 'name': 'label.country.Dominica' },
    { 'id': 'flag flag-be', 'name': 'label.country.Belgium' },
    { 'id': 'flag flag-ni', 'name': 'label.country.Nicaragua' },
    { 'id': 'flag flag-ua', 'name': 'label.country.Ukraine' },
    { 'id': 'flag flag-mz', 'name': 'label.country.Mozambique' },
    { 'id': 'flag flag-pf', 'name': 'label.country.FrenchPolynesia' },
    { 'id': 'flag flag-tn', 'name': 'label.country.Tunisia' },
    { 'id': 'flag flag-ee', 'name': 'label.country.Estonia' },
    { 'id': 'flag flag-xk', 'name': 'label.country.Kosovo' },
    { 'id': 'flag flag-sx', 'name': 'label.country.SintMaarten' },
    { 'id': 'flag flag-sd', 'name': 'label.country.Sudan' },
    { 'id': 'flag flag-gd', 'name': 'label.country.Grenada' },
    { 'id': 'flag flag-ci', 'name': 'label.country.IvoryCoast' },
    { 'id': 'flag flag-sz', 'name': 'label.country.Swaziland' },
    { 'id': 'flag flag-cl', 'name': 'label.country.Chile' },
    { 'id': 'flag flag-fi', 'name': 'label.country.Finland' },
    { 'id': 'flag flag-ga', 'name': 'label.country.Gabon' },
    { 'id': 'flag flag-jp', 'name': 'label.country.Japan' },
    { 'id': 'flag flag-de', 'name': 'label.country.Germany' },
    { 'id': 'flag flag-np', 'name': 'label.country.Nepal' },
    { 'id': 'flag flag-re', 'name': 'label.country.Reunion' },
    { 'id': 'flag flag-bg', 'name': 'label.country.Bulgaria' },
    { 'id': 'flag flag-sc', 'name': 'label.country.Seychelles' },
    { 'id': 'flag flag-ng', 'name': 'label.country.Nigeria' },
    { 'id': 'flag flag-qa', 'name': 'label.country.Qatar' },
    { 'id': 'flag flag-mk', 'name': 'label.country.NorthMacedonia' },
    { 'id': 'flag flag-aw', 'name': 'label.country.Aruba' },
    { 'id': 'flag flag-kn', 'name': 'label.country.SaintKittsAndNevis' },
    { 'id': 'flag flag-al', 'name': 'label.country.Albania' },
    { 'id': 'flag flag-bw', 'name': 'label.country.Botswana' },
    { 'id': 'flag flag-um', 'name': 'label.country.UnitedStatesMinorOutlyingIslands' },
    { 'id': 'flag flag-ky', 'name': 'label.country.CaymanIslands' },
    { 'id': 'flag flag-tt', 'name': 'label.country.TrinidadAndTobago' },
    { 'id': 'flag flag-so', 'name': 'label.country.Somalia' },
    { 'id': 'flag flag-lt', 'name': 'label.country.Lithuania' },
    { 'id': 'flag flag-by', 'name': 'label.country.Belarus' },
    { 'id': 'flag flag-bb', 'name': 'label.country.Barbados' },
    { 'id': 'flag flag-us', 'name': 'label.country.UnitedStatesOfAmerica' },
    { 'id': 'flag flag-md', 'name': 'label.country.Moldova' },
    { 'id': 'flag flag-ag', 'name': 'label.country.AntiguaAndBarbuda' },
    { 'id': 'flag flag-hm', 'name': 'label.country.HeardIslandAndMcDonaldIslands' },
    { 'id': 'flag flag-as', 'name': 'label.country.AmericanSamoa' },
    { 'id': 'flag flag-eg', 'name': 'label.country.Egypt' },
    { 'id': 'flag flag-sv', 'name': 'label.country.ElSalvador' },
    { 'id': 'flag flag-sl', 'name': 'label.country.SierraLeone' },
    { 'id': 'flag flag-fk', 'name': 'label.country.FalklandIslands' },
    { 'id': 'flag flag-am', 'name': 'label.country.Armenia' },
    { 'id': 'flag flag-ck', 'name': 'label.country.CookIslands' },
    { 'id': 'flag flag-tw', 'name': 'label.country.Taiwan' },
    { 'id': 'flag flag-kh', 'name': 'label.country.Cambodia' },
    { 'id': 'flag flag-to', 'name': 'label.country.Tonga' },
    { 'id': 'flag flag-se', 'name': 'label.country.Sweden' },
    { 'id': 'flag flag-cd', 'name': 'label.country.DemocraticRepublicOfTheCongo' },
    { 'id': 'flag flag-pn', 'name': 'label.country.Pitcairn' },
    { 'id': 'flag flag-gr', 'name': 'label.country.Greece' },
    { 'id': 'flag flag-id', 'name': 'label.country.Indonesia' },
    { 'id': 'flag flag-vc', 'name': 'label.country.SaintVincentAndTheGrenadines' },
    { 'id': 'flag flag-somaliland', 'name': 'label.country.Somaliland' },
    { 'id': 'flag flag-bi', 'name': 'label.country.Burundi' },
    { 'id': 'flag flag-pk', 'name': 'label.country.Pakistan' },
    { 'id': 'flag flag-pr', 'name': 'label.country.PuertoRico' },
    { 'id': 'flag flag-bd', 'name': 'label.country.Bangladesh' },
    { 'id': 'flag flag-co', 'name': 'label.country.Colombia' },
    { 'id': 'flag flag-fm', 'name': 'label.country.FederatedStatesOfMicronesia' },
    { 'id': 'flag flag-bm', 'name': 'label.country.Bermuda' },
    { 'id': 'flag flag-ar', 'name': 'label.country.Argentina' },
    { 'id': 'flag flag-bv', 'name': 'label.country.BouvetIsland' },
    { 'id': 'flag flag-sb', 'name': 'label.country.SolomonIslands' },
    { 'id': 'flag flag-mq', 'name': 'label.country.Martinique' },
    { 'id': 'flag flag-eh', 'name': 'label.country.WesternSahara' },
    { 'id': 'flag flag-bh', 'name': 'label.country.Bahrain' },
    { 'id': 'flag flag-it', 'name': 'label.country.Italy' },
    { 'id': 'flag flag-hr', 'name': 'label.country.Croatia' },
    { 'id': 'flag flag-sa', 'name': 'label.country.SaudiArabia' },
    { 'id': 'flag flag-mv', 'name': 'label.country.Maldives' },
    { 'id': 'flag flag-mg', 'name': 'label.country.Madagascar' },
    { 'id': 'flag flag-dz', 'name': 'label.country.Algeria' },
    { 'id': 'flag flag-gg', 'name': 'label.country.Guernsey' },
    { 'id': 'flag flag-gm', 'name': 'label.country.Gambia' },
    { 'id': 'flag flag-af', 'name': 'label.country.Afghanistan' },
    { 'id': 'flag flag-li', 'name': 'label.country.Liechtenstein' },
    { 'id': 'flag flag-sr', 'name': 'label.country.Suriname' },
    { 'id': 'flag flag-vg', 'name': 'label.country.VirginIslandsBritish' },
    { 'id': 'flag flag-cr', 'name': 'label.country.CostaRica' },
    { 'id': 'flag flag-tc', 'name': 'label.country.TurksAndCaicosIslands' },
    { 'id': 'flag flag-ao', 'name': 'label.country.Angola' },
    { 'id': 'flag flag-ma', 'name': 'label.country.Morocco' },
    { 'id': 'flag flag-mr', 'name': 'label.country.Mauritania' },
    { 'id': 'flag flag-gn', 'name': 'label.country.Guinea' },
    { 'id': 'flag flag-ne', 'name': 'label.country.Niger' },
    { 'id': 'flag flag-nf', 'name': 'label.country.NorfolkIsland' },
    { 'id': 'flag flag-wf', 'name': 'label.country.WallisAndFutuna' },
    { 'id': 'flag flag-hk', 'name': 'label.country.HongKong' },
    { 'id': 'flag flag-gf', 'name': 'label.country.FrenchGuiana' },
    { 'id': 'flag flag-ps', 'name': 'label.country.StateOfPalestine' },
    // { 'id': 'flag flag-ic', 'name': 'label.country.' },
    { 'id': 'flag flag-cw', 'name': 'label.country.Curaçao' },
    { 'id': 'flag flag-ml', 'name': 'label.country.Mali' },
    { 'id': 'flag flag-ax', 'name': 'label.country.AlandIslands' },
    { 'id': 'flag flag-gl', 'name': 'label.country.Greenland' },
    { 'id': 'flag flag-dj', 'name': 'label.country.Djibouti' },
    { 'id': 'flag flag-cn', 'name': 'label.country.China' },
    { 'id': 'flag flag-ht', 'name': 'label.country.Haiti' },
    { 'id': 'flag flag-lr', 'name': 'label.country.Liberia' },
    { 'id': 'flag flag-tg', 'name': 'label.country.Togo' },
    { 'id': 'flag flag-ba', 'name': 'label.country.BosniaAndHerzegovina' },
    { 'id': 'flag flag-ge', 'name': 'label.country.Georgia' },
    { 'id': 'flag flag-bz', 'name': 'label.country.Belize' },
    { 'id': 'flag flag-au', 'name': 'label.country.Australia' },
    { 'id': 'flag flag-iq', 'name': 'label.country.Iraq' },
    { 'id': 'flag flag-cm', 'name': 'label.country.Cameroon' },
    { 'id': 'flag flag-gw', 'name': 'label.country.GuineaBissau' },
    { 'id': 'flag flag-az', 'name': 'label.country.Azerbaijan' },
    { 'id': 'flag flag-na', 'name': 'label.country.Namibia' },
    { 'id': 'flag flag-fj', 'name': 'label.country.Fiji' },
    { 'id': 'flag flag-zw', 'name': 'label.country.Zimbabwe' },
    { 'id': 'flag flag-bs', 'name': 'label.country.Bahamas' },
    { 'id': 'flag flag-il', 'name': 'label.country.Israel' },
    { 'id': 'flag flag-nz', 'name': 'label.country.NewZealand' },
    { 'id': 'flag flag-me', 'name': 'label.country.Montenegro' },
    { 'id': 'flag flag-si', 'name': 'label.country.Slovenia' },
    { 'id': 'flag flag-nc', 'name': 'label.country.NewCaledonia' },
    { 'id': 'flag flag-lb', 'name': 'label.country.Lebanon' },
  ];
}
